// extracted by mini-css-extract-plugin
export default {"pageWrapper":"page-wrapper_pageWrapper__AwmKT","content":"page-wrapper_content__zbcPJ"};